import { getHeaders } from "utils/Utils";
import client from "./client";

const endpoint = "career-walk-in-candidates/";

const submitCandidateIntake = ({
  token,
  personalityType,
  questionnaireText,
  cvUrl,
}) => {
  const body = {
    personalityType,
    questionnaireText,
    cvUrl,
  };

  return client.post(`${endpoint}intake/${token}`, body, getHeaders());
};

const uploadCandidateCv = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return client.post(`${endpoint}cv`, formData, {
    ...getHeaders(),
    headers: {
      ...(getHeaders()?.headers || {}),
      "Content-Type": "multipart/form-data",
    },
  });
};

export { submitCandidateIntake, uploadCandidateCv };
